<template>
  <div class="xcard">
    <h3 class="text-center" style="margin-top: 0">Verificador de Cobranzas</h3>
    <p class="text-center">{{ xprograma.nombre }}</p>

    <v-checkbox v-model="mostrar_vacios" label="Mostrar vacios" />

    <v-progress-linear v-if="loading" indeterminate height="3" />

    <template>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Ins</th>
              <th class="text-left">Estudiante</th>
              <th class="text-left">Saldo a la fecha actual</th>
              <th class="text-left">Moodle Username</th>
              <th class="text-left">Accion a realizar</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in inscripciones" :key="item.id">
              <template v-if="item.saldo_now || mostrar_vacios">
                <td>{{ item.id }}</td>
                <td>[{{ item.estudiante.num_doc }}] {{ getestudianteStr(item.estudiante) }}</td>
                <td>
                  <v-btn v-if="item.saldo_now" text color="primary" @click="opendetalles(item)">
                    <v-icon>mdi-eye </v-icon> {{ item.saldo_now }}
                  </v-btn>
                  <v-progress-linear v-if="item.loadinddeta" indeterminate height="2" />
                </td>
                <td>{{ item.estudiante.usuario_moodle }}</td>
                <td>
                  {{ item.accion }}
                  <v-progress-linear v-if="item.loadingapplying" indeterminate height="2" color="purple" />
                </td>
              </template>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>

    <v-btn color="green darken-4" :disabled="loading" dark @click="aplicarAcciones()"> Aplicar Acciones </v-btn>

    <DetailIns ref="detailins" />
  </div>
</template>

<script>
  import CobranzaService from './cobranzasService';
  import DetailIns from '../Inscripcion/DetailsIns.vue';
  import { mapState } from 'vuex';
  export default {
    data() {
      return {
        cobranzaService: new CobranzaService(),
        loading: false,
        mostrar_vacios: false,
        plataforma: {},
        numero_peticiones: 0,
        inscripciones: [],
        xprograma: {
          nombre: '',
        },
      };
    },
    components: {
      DetailIns,
    },
    computed: {
      ...mapState({ programa: (state) => state.programa.value }),
    },
    watch: {},
    methods: {
      getestudianteStr(e) {
        return `${e.pri_apellido} ${e.seg_apellido} ${e.nombres}`;
      },
      getEstadoInsStr(ins) {
        var str = '';
        if (ins == 0) str = 'Pre inscrito';
        else if (ins == 1) str = 'Inscrito';
        else if (ins == 2) str = 'retirado';
        else if (ins == 3) str = 'cambiado';
        else if (ins == 4) str = 'congelado';
        else if (ins == 5) str = 'pagado';
        return str;
      },
      opendetalles(inscripcion) {
        inscripcion.loadinddeta = true;
        this.$refs.detailins.showThisView('', inscripcion.id, inscripcion);
      },
      getInscripciones(plataformas) {
        this.loading = true;
        this.numero_peticiones = 0;
        let programa_id = this.$route.query.programa_id;
        this.cobranzaService.getInscripciones(this, programa_id, (data) => {
          data.inscripciones.sort(
            (a, b) => a.estado_ins - b.estado_ins || a.estudiante.pri_apellido.localeCompare(b.estudiante.pri_apellido),
          );
          data.inscripciones.map((x) => {
            x.estado_ins2 = this.getEstadoInsStr(x.estado_ins);
            x.kardex = [];
            x.saldo_now = '';
            x.accion = '';
            x.loading_kardex = true;
            x.loadinddeta = false;
            x.loadingapplying = false;
          });
          data.inscripciones.forEach(async (ins) => await this.getPlanKardex(ins));
          //window.console.log(data);
          this.inscripciones = data.inscripciones;
          this.xprograma.nombre = data.nombre_compuesto;
          this.plataforma = plataformas.find((p) => p.id == data.plataforma_id);
          if (!this.plataforma) {
            this.$root.$notify.show(`El programa no tiene Asignado una Plataforma Moodle`, {
              color: 'red',
              x: 'right',
            });
          }
          //this.loading = false;
        });
      },
      async getPlataformas() {
        const res = await this.cobranzaService.getOnlyPlataformas(this, (data) => data);
        this.getInscripciones(res);
      },
      async getPlanKardex(inscripcion) {
        const res = await this.cobranzaService.getPlanKardex(inscripcion.id);
        this.numero_peticiones += 1;
        if (res) {
          inscripcion.kardex = res.data;
          res.data.forEach((p) => {
            let date = new Date(p.fecha_pago);
            let now = new Date();
            if (date < now && p.saldo > 0) {
              inscripcion.saldo_now += `${p.saldo} bs. [${p.fecha_pago}] `;
              inscripcion.accion = 'Suspender ultimo Modulo del Moodle';
            }
          });
        }
        inscripcion.loading_kardex = false;
        if (this.inscripciones.length == this.numero_peticiones) this.loading = false;
      },
      async aplicarAcciones() {
        // let programa_id = this.$route.query.programa_id;
        if (!this.plataforma) {
          this.$root.$notify.show(`El programa no tiene Asignado una Plataforma Moodle`, { color: 'red', x: 'right' });
          return;
        }
        const personas = [];
        this.inscripciones.forEach((i) => {
          if (i.saldo_now) {
            personas.push(i.estudiante);
            i.loadingapplying = true;
          }
        });
        this.loading = true;
        // const res = await this.cobranzaService.cambiarEstadoInModulosMoodle(programa_id, personas, this.plataforma);
        // res.forEach((r) => {
        //   const ex = this.inscripciones.find((x) => x.estudiante.usuario_moodle == r.username);
        //   if (ex) ex.accion = r.result;
        // });
        this.inscripciones.forEach((i) => (i.loadingapplying = false));
        this.loading = false;
      },
      getstorePrograma() {
        const sto = window.localStorage.getItem('select_programa');
        if (sto && !this.programa) {
          const p = JSON.parse(sto);
          //window.console.log('sto', p);
          this.$store.dispatch('programa/selectPrograma', p);
        }
      },
    },
    async mounted() {
      let programa_id = this.$route.query;
      this.getstorePrograma();
      await this.getPlataformas();

      window.console.log(programa_id);
    },
  };
</script>
